// Filter and Search
document.addEventListener('DOMContentLoaded', function () {
  const brandOptions = document.querySelectorAll('[js-brand-option]');
  const filterTitle = document.querySelector('[js-brand-filter-title-field]');
  const searchInput = document.querySelector('[js-search-input-field] input[type="text"]');
  const productBoxes = document.querySelectorAll('[js-brand-product-card]');

  let currentFilter = ''; 
  let currentSearch = ''; 

  function applyFilterAndSearch() {
    productBoxes.forEach(box => {
      const boxClassList = box.className.split(/\s+/);
      const titleEl = box.querySelector('[js-product-card-title]');
      const descEl = box.querySelector('[js-product-card-description]');
      const titleText = titleEl ? titleEl.textContent.toLowerCase() : '';
      const descText = descEl ? descEl.textContent.toLowerCase() : '';

      const matchesFilter = !currentFilter || boxClassList.includes(currentFilter);
      const matchesSearch = !currentSearch || titleText.includes(currentSearch) || descText.includes(currentSearch);

      box.style.display = (matchesFilter && matchesSearch) ? 'block' : 'none';
    });
  }

  brandOptions.forEach(option => {
    option.addEventListener('click', function () {
      currentFilter = this.getAttribute('value');

      if (filterTitle) {
        filterTitle.textContent = this.textContent.trim();
        filterTitle.click();
      }

      applyFilterAndSearch();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      currentSearch = this.value.trim().toLowerCase();
      applyFilterAndSearch();
    });
  }
});

// Sorting

document.addEventListener('DOMContentLoaded', function () {
  const sortTabs = document.querySelectorAll('[js-affiliate-sorting-tab]');
  const productContainer = document.querySelector('[js-product-card-container]');
  const originalProductList = Array.from(productContainer.children);

  function getTitleText(product) {
    const titleEl = product.querySelector('[js-product-card-title] span');
    return titleEl ? titleEl.textContent.trim().toLowerCase() : '';
  }

  sortTabs.forEach(tab => {
    tab.addEventListener('click', function () {
      sortTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      const sortType = this.textContent.trim();

      let sortedProducts;

      if (sortType === 'Most popular') {
        sortedProducts = [...originalProductList];
      } else if (sortType === 'A-Z') {
        sortedProducts = [...originalProductList].sort((a, b) => {
          return getTitleText(a).localeCompare(getTitleText(b));
        });
      } else if (sortType === 'Z-A') {
        sortedProducts = [...originalProductList].sort((a, b) => {
          return getTitleText(b).localeCompare(getTitleText(a));
        });
      }

      productContainer.innerHTML = '';
      sortedProducts.forEach(product => {
        productContainer.appendChild(product);
      });
    });
  });
});